import { cancelled, put, takeLatest } from 'redux-saga/effects';

import { loadUserCollectionsAction, loadUserCollectionsCancelled } from '../../actions';

import { loadUserCollections } from './user.collections.utils';

function* handleLoadUserCollectionsAction({ payload }: ReturnType<typeof loadUserCollectionsAction>) {
    const { isForce } = payload;

    try {
        yield* loadUserCollections(isForce);
    } finally {
        const isCancelled: boolean = yield cancelled();
        if (isCancelled) {
            yield put(loadUserCollectionsCancelled());
        }
    }
}

function* saga() {
    yield takeLatest(loadUserCollectionsAction, handleLoadUserCollectionsAction);
}

export { saga };
